import { Link } from 'react-router-dom';
import { formatMemoDateDisplay } from '../../lib/memoDocx';
import { formatSubmittedAt, statusClass, STATUS_LABEL } from '../../lib/accountCreationUi';
import type { ApplicationSubmission, InternalMemoFormData } from '../../types/applicationForm';

type MemoListRowProps = {
  row: ApplicationSubmission;
  detailPath: string;
};

export function MemoListRow({ row, detailPath }: MemoListRowProps) {
  const data = row.form_data as InternalMemoFormData;
  const subject = data.subject?.trim() || row.company_name || '—';
  const fromLine = data.issued_by?.trim() || data.from_line?.trim() || row.submitted_by || '—';
  const memoDate = formatMemoDateDisplay(data.date) || data.date || '—';

  return (
    <Link to={detailPath} className="memo-list-row">
      <span className="memo-list-row__ref">{row.application_no}</span>

      <span className="memo-list-row__subject">{subject}</span>

      <span className="memo-list-row__text memo-list-row__text--to">
        {data.to?.trim() || '—'}
      </span>

      <span className="memo-list-row__text">{fromLine}</span>

      <span className="memo-list-row__text memo-list-row__text--date">{memoDate}</span>

      <span className={statusClass(row.status)}>{STATUS_LABEL[row.status]}</span>

      <span className="memo-list-row__text memo-list-row__text--saved">
        {formatSubmittedAt(row.submitted_at)}
      </span>

      <span className="memo-list-row__chevron" aria-hidden>
        ›
      </span>
    </Link>
  );
}
